// extracted by mini-css-extract-plugin
export default {"rotateArrow":"fouNYlLydmx"};